var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transaction_header"
  }, [_c('button', {
    staticClass: "transaction_block-close",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.close')) + " ")]), _c('div', {
    staticClass: "transaction_header-title"
  }, [_vm._v(" " + _vm._s(_vm.getBillText) + " - " + _vm._s(_vm._f("date")(_vm.transaction.created_at, 'DD.MM.YYYY HH:mm')) + " ")]), _c('div', {
    staticClass: "transaction_header-info",
    class: {
      'editable': _vm.isEditableAmount
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onEditAmount($event);
      }
    }
  }, [_c('span', {
    staticClass: "amount_wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedBillAmount)
    }
  }), _c('span', {
    staticClass: "pencil"
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }